import {PAPER_BIN_LOADING} from "../actions/paperBinActions";

const INITIAL_STATE = {
  loading: false,
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {

    case PAPER_BIN_LOADING:
      return { ...state, loading: action.payload };

    default:
      return state;
  }
};




// WEBPACK FOOTER //
// ./src/app/paperbin/reducer/PaperBinReducer.js